import Frames from "@frog/source/engine/animating/Frames.js"

const PAUSE_FRAMES = [
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
    require("./eyes16.png"),
]

const SEPARATE_BLINK_FRAMES = [
    require("./eyes1.png"),
    require("./eyes2.png"),
    require("./eyes3.png"),
    require("./eyes4.png"),
    require("./eyes5.png"),
    require("./eyes6.png"),
    require("./eyes7.png"),
    require("./eyes8.png"),
    require("./eyes9.png"),
    require("./eyes10.png"),
    require("./eyes11.png"),
    require("./eyes12.png"),
    require("./eyes13.png"),
    require("./eyes14.png"),
    require("./eyes15.png"),
]

const TOGETHER_BLINK_FRAMES = [
    require("./eyest2.png"),
    require("./eyest1.png"),
    require("./eyest2.png"),
]

const TOGETHER_DOUBLE_BLINK_FRAMES = [
    require("./eyest2.png"),
    require("./eyest1.png"),
    require("./eyest2.png"),
    require("./eyest3.png"),
    require("./eyest2.png"),
    require("./eyest1.png"),
    require("./eyest2.png"),
]

export default {
    "static": require("./eyest3.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 70,
            "images": [
                ...PAUSE_FRAMES,
                ...SEPARATE_BLINK_FRAMES,
                ...PAUSE_FRAMES,
                ...SEPARATE_BLINK_FRAMES,
                ...PAUSE_FRAMES,
                ...TOGETHER_DOUBLE_BLINK_FRAMES,
            ]
        })
    },
}
